import React, { useMemo } from 'react';
import { Paper, Select, MenuItem, InputLabel, FormControl, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

const FilterRowTop = ({
  selectedYear,
  setSelectedYear,
  yearOptions,
  dateRange,
  setDateRange,
  statusFilter,
  setStatusFilter,
  documentCountFilter,
  setDocumentCountFilter,
}) => {
  
  // 1. Calculate the year constraints
  const yearConstraints = useMemo(() => {
    const year = parseInt(selectedYear);
    if (isNaN(year)) {
      return { min: null, max: null };
    }
    
    // Start of the selected year (January 1st)
    const yearStart = new Date(year, 0, 1);
    
    // End of the selected year (December 31st)
    const yearEnd = new Date(year, 11, 31);

    return { min: yearStart, max: yearEnd };
  }, [selectedYear]);

  // Extract year min/max dates
  const { min: yearMinDate, max: yearMaxDate } = yearConstraints;

  // 🎯 NEW HANDLER TO RESET DATE RANGE WHEN YEAR CHANGES
  const handleYearChange = (e) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);

    const yearInt = parseInt(newYear);
    if (isNaN(yearInt)) return;
    
    // Calculate the start and end of the NEW selected year
    const newYearStart = new Date(yearInt, 0, 1); // January 1st
    const newYearEnd = new Date(yearInt, 11, 31); // December 31st

    // Reset dateRange to the full span of the new year
    setDateRange({
        startDate: newYearStart,
        endDate: newYearEnd,
    });
  };

  return (
    <Paper
      elevation={1}
      sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'center' }}
    >
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel>Year</InputLabel>
        <Select
          value={selectedYear}
          label="Year"
          // 🎯 Use the new handler here
          onChange={handleYearChange}
        >
          {yearOptions.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <DatePicker
        label="Start Date"
        value={dateRange.startDate}
        onChange={(newValue) =>
          setDateRange((prev) => ({ ...prev, startDate: newValue }))
        }
        renderInput={(params) => <TextField {...params} />}
        
        // Apply year constraints
        minDate={yearMinDate}
        maxDate={dateRange.endDate || yearMaxDate} 
      />
      <DatePicker
        label="End Date"
        value={dateRange.endDate}
        onChange={(newValue) =>
          setDateRange((prev) => ({ ...prev, endDate: newValue }))
        }
        renderInput={(params) => <TextField {...params} />}
        
        // Apply year constraints
        minDate={dateRange.startDate || yearMinDate}
        maxDate={yearMaxDate}
      />
      {/* ... (Status and Document Filters remain the same) ... */}
      <FormControl sx={{ minWidth: 210 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={statusFilter}
          label="Status"
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <MenuItem value="Both">Both</MenuItem>
          <MenuItem value="Open">Open</MenuItem>
          <MenuItem value="Closed">Closed</MenuItem>
        </Select>
      </FormControl>
      
      <FormControl sx={{ minWidth: 210 }}>
        <InputLabel>Documents</InputLabel>
        <Select
          value={documentCountFilter}
          label="Documents"
          onChange={(e) => setDocumentCountFilter(e.target.value)}
        >
          <MenuItem value="Any">Any</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </Select>
      </FormControl>
      
    </Paper>
  );
};

export default FilterRowTop;